<template>
    <div class="o-movie-slot">
        <span class="movie-slot-time">
            {{ item.ShowTime }}
        </span>
        <span class="movie-slot-screen">
            {{ item.ScreenName }}
        </span>
        <span class="movie-slot-seats">
            <template v-if="item.CidSeatsLeft">
                {{ item.CidSeatsLeft }} {{ $t('o-movie-schedule.seats') }}
            </template>
            <template v-else>{{ $t('o-movie-schedule.no-seats') }}</template>
        </span>
        <AButton
            theme="dark"
            :disabled="!isAvailableSeats"
            :text="$t('o-movie-schedule.tickets')"
            class="movie-slot-button"
            @onClick="onBuyTicket"
        />
    </div>
</template>

<script>
import AButton from '../../atoms/a-button/a-button.vue';

export default {
    name: 'OMovieSlot',
    components: {
        AButton
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailableSeats() {
            return this.item.CidSeatsLeft !== 0;
        }
    },
    methods: {
        onBuyTicket() {
            const payload = {
                time: this.item.ShowTime,
                screen: this.item.ScreenName,
                url: this.item.TicketSaleUrl
            };

            this.$emit('onBuyTicket', payload);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
